import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export const muiStyles = makeStyles((theme: typeof muiTheme) => ({
    actionsButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        backgroundColor: '#4A90C2',
        color: '#fff',
        border: 'none',
        borderRadius: 6,
        padding: '14px',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
        cursor: 'pointer',
        width: '110px',
        '&:hover': { backgroundColor: '#3f7fae' }
    },
    menuIcon: {
        color: '#fff',
        fontSize: '16px'
    },
    dropdownItem: {
        fontSize: '0.8rem',
        display: 'block',
        width: '110px',
        padding: '8px 0',
        textAlign: 'center',
        border: '1px solid #E0E0E0',
        cursor: 'pointer',
        transition: 'background 0.2s',
        background: '#FFF',
        '&:hover': { background: '#ECECEC' }
    },
    firstDropdownItem: {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px'
    },
    lastDropdownItem: {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        boxShadow: '0 3px 3px rgba(30,30,30,0.3)'
    }
}));